import { render, staticRenderFns } from "./register-code.component.vue?vue&type=template&id=60639a19"
import script from "./register-code.component.vue?vue&type=script&lang=js"
export * from "./register-code.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports